import script from "./TaskList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskList.vue?vue&type=script&setup=true&lang=ts"

import "./TaskList.vue?vue&type=style&index=0&id=8ecb4a52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ecb4a52"]])

export default __exports__